import classNames from 'classnames'

import { IGridItemProps } from './models/IGrid'

import styles from './Grid.module.scss'

export const Item = ({
  children,
  className,
  xs,
  sm,
  md,
  lg,
  xl,
  alignSelf,
  onClick,
}: IGridItemProps) => {
  return (
    <div
      onMouseDown={onClick}
      className={classNames(
        styles.item,
        {
          [styles[`alignSelf-${alignSelf}`]]: alignSelf,
          [styles[`xs-${xs}`]]: xs,
          [styles[`sm-${sm}`]]: sm,
          [styles[`md-${md}`]]: md,
          [styles[`lg-${lg}`]]: lg,
          [styles[`xl-${xl}`]]: xl,
        },
        className || ''
      )}
    >
      {children}
    </div>
  )
}
